import React from "react";
import "./book-page.m.css";

export default function Newsletter() {
  return (
    <div
      id="newsletter-section"
      styleName="newsletter-section"
      onClick={() => {
        window.location.href = "/book-club";
      }}
    >
      {/* Desktop */}
      <img
        loading="lazy"
        src="https://images.assettype.com/newslaundry/2026-06-30/ngfd44vp/newsletter.png"
        alt=""
        styleName="newsletter-image newsletter-desktop"
      />

      {/* Mobile */}
      <img
        loading="lazy"
        src="https://images.assettype.com/newslaundry/2026-07-03/uzmfg9gx/NEWSLETTER.png"
        alt=""
        styleName="newsletter-image newsletter-mobile"
      />
    </div>
  );
}